export default __webpack_public_path__ + "static/media/Sun.b5dcae4c.svg";